import { SearchFormType } from "../search-page-type.enum";
import { SearchParam, SearchParamType } from "../search-param.model";

export function executionUserFilterDefs(): SearchParam[] {
    return [
        {
            "property": {
                "name": "surname",
                "value": ""
            },
            "layout": {
                "row": 0,
                "column": 0,
                "autofocus": true,
                "stretch": true
            }
        },
        {
            "property": {
                "name": "name",
                "value": ""
            },
            "layout": {
                "row": 0,
                "column": 1,
                "stretch": true
            }
        },
        {
            "property": {
                "name": "idProvenance",
                "value": null
            },
            "layout": {
                "row": 0,
                "column": 2,
                "stretch": true
            }
        },
        {
            "property": {
                "name": "idRoom",
                "value": null
            },
            "layout": {
                "row": 0,
                "column": 3,
                "stretch": true
            }
        },
        {
            "property": {
                "name": "date",
                "value": {
                    "from": "2024-02-04T00:00:00.000Z",
                    "to": "2024-05-04T23:59:59.000Z"
                },
                "defaultValue": {
                    "from": "0#-2#0",
                    "to": "0#0#0"
                }
            },
            "layout": {
                "row": 0,
                "column": 4,
                "stretch": true
            }
        },
        {
            "property": {
                "name": "patientId",
                "value": ""
            },
            "layout": {
                "row": 1,
                "column": 0,
                "stretch": true
            }
        },
        {
            "property": {
                "name": "idProvenances",
                "value": null
            },
            "layout": {
                "row": 1,
                "column": 1,
                "stretch": true
            }
        },
        {
            "property": {
                "name": "idBusinessUnits",
                "value": null
            },
            "layout": {
                "row": 1,
                "column": 2,
                "stretch": true
            }
        },
        {
            "property": {
                "name": "IdAgenda",
                "value": null
            },
            "layout": {
                "row": 1,
                "column": 3,
                "stretch": true
            }
        },
        {
            "property": {
                "name": "IdEquipment",
                "value": null
            },
            "layout": {
                "row": 1,
                "column": 4,
                "stretch": true
            }
        },
        {
            "property": {
                "name": "Modality",
                "value": null
            },
            "layout": {
                "row": 1,
                "column": 5,
                "stretch": true
            }
        },
        {
            "property": {
                "name": "taxCode",
                "value": "",
                "defaultValue": ""
            },
            "layout": {
                "row": 1,
                "column": 6,
                "stretch": true
            }
        },
        {
            "property": {
                "name": "hospitalizationNumber",
                "value": "",
                "defaultValue": ""
            },
            "layout": {
                "row": 1,
                "column": 7,
                "stretch": true
            }
        },
        {
            "property": {
                "name": "braceletNumber",
                "value": "",
                "defaultValue": ""
            },
            "layout": {
                "row": 1,
                "column": 8,
                "stretch": true
            }
        },
        {
            "property": {
                "name": "idReferringPhysician",
                "value": null
            },
            "layout": {
                "row": 1,
                "column": 9,
                "stretch": true
            }
        },
        {
            "property": {
                "name": "IdExecutor",
                "value": null
            },
            "layout": {
                "row": 1,
                "column": 10,
                "stretch": true
            }
        }
    ];

}

export function executionSiteFilterDefs(): SearchParam[] {
    return [
        {
            "active": true,
            "property": {
                "name": "surname",
                "type": SearchParamType.string
            },
            "labelTranslationKey": "LastName"
        },
        {
            "active": true,
            "property": {
                "name": "name",
                "type": SearchParamType.string
            },
            "labelTranslationKey": "FirstName"
        },
        {
            "active": true,
            "property": {
                "name": "idProvenance",
                "type": SearchParamType.multiSelect,
                "itemsSourceInfo": {
                    "form": SearchFormType.EXECUTION,
                    "controllerName": "ListWorkFlow",
                    "methodName": "GetListItems?lsName=lsProvenance",
                    "enableTooltip": true,
                    "sortCollectionDataInfo": {
                        "field": "description"
                    },
                    "displayProperty": "description",
                    "refSearchParamPropertyNames": ["idProvenances"],
                    "foreingKeys": ["IdProvenanceGroup"]
                }
            },
            "labelTranslationKey": "Provenance"
        },
        {
            "active": true,
            "property": {
                "name": "idRoom",
                "type": SearchParamType.select,
                "itemsSourceInfo": {
                    "form": SearchFormType.EXECUTION,
                    "controllerName": "ListWorkFlow",
                    "methodName": "GetListItems?lsName=lsRoom",
                    "enableTooltip": true,
                    "sortCollectionDataInfo": {
                        "field": "description"
                    },
                    "displayProperty": "description"
                }
            },
            "labelTranslationKey": "Room"
        },
        {
            "active": true,
            "property": {
                "name": "date",
                "type": SearchParamType.fromTo
            },
            "labelTranslationKey": {
                "from": "From",
                "to": "To",
                "label": "ExamDate"
            }
        },
        {
            "active": true,
            "property": {
                "name": "patientId",
                "type": SearchParamType.string
            },
            "labelTranslationKey": "PatientId"
        },
        {
            "active": true,
            "property": {
                "name": "idProvenances",
                "type": SearchParamType.select,
                "itemsSourceInfo": {
                    "form": SearchFormType.EXECUTION,
                    "controllerName": "ListWorkFlow",
                    "methodName": "GetListItems?lsName=lsProvenanceGroup",
                    "enableTooltip": true,
                    "sortCollectionDataInfo": {
                        "field": "description"
                    },
                    "displayProperty": "description"
                }
            },
            "labelTranslationKey": "Provenances"
        },
        {
            "active": true,
            "property": {
                "name": "idBusinessUnits",
                "type": SearchParamType.multiSelect,
                "itemsSourceInfo": {
                    "form": SearchFormType.EXECUTION,
                    "controllerName": "ListWorkFlow",
                    "methodName": "GetListItems?lsName=lsBusinessUnit",
                    "enableTooltip": true,
                    "sortCollectionDataInfo": {
                        "field": "description"
                    },
                    "displayProperty": "description"
                }
            },
            "labelTranslationKey": "BusinessUnit"
        },
        {
            "active": true,
            "property": {
                "name": "IdAgenda",
                "type": SearchParamType.filterSelect,
                "itemsSourceInfo": {
                    "form": SearchFormType.EXECUTION,
                    "controllerName": "ListWorkFlow",
                    "methodName": "GetListItems?lsName=lsAgenda",
                    "displayProperty": "description",
                    "enableTooltip": true,
                    "sortCollectionDataInfo": {
                        "field": "description"
                    },
                    "refSearchParamPropertyNames": ["IdEquipment"],
                    "foreingKeys": ["IdEquipment"]
                }
            },
            "labelTranslationKey": "Agenda"
        },
        {
            "active": true,
            "property": {
                "name": "IdEquipment",
                "type": SearchParamType.filterSelect,
                "itemsSourceInfo": {
                    "form": SearchFormType.EXECUTION,
                    "controllerName": "ListWorkFlow",
                    "methodName": "GetListItems?lsName=lsEquipment",
                    "displayProperty": "description",
                    "enableTooltip": true,
                    "refSearchParamPropertyNames": ["idProvenance", "idRoom"],
                    "foreingKeys": ["IdProvenance", "IdRoom"],
                    "sortCollectionDataInfo": {
                        "field": "description"
                    }
                }
            },
            "labelTranslationKey": "Equipment"
        },
        {
            "active": true,
            "property": {
                "name": "Modality",
                "type": SearchParamType.select,
                "itemsSourceInfo": {
                    "form": SearchFormType.EXECUTION,
                    "controllerName": "ListWorkFlow",
                    "methodName": "GetListItems?lsName=lsModality",
                    "enableTooltip": true,
                    "sortCollectionDataInfo": {
                        "field": "description"
                    },
                    "displayProperty": "description"
                }
            },
            "labelTranslationKey": "Modality"
        },
        {
            "active": true,
            "property": {
                "name": "taxCode",
                "type": SearchParamType.string
            },
            "labelTranslationKey": "TaxCode"
        },
        {
            "active": true,
            "property": {
                "name": "hospitalizationNumber",
                "type": SearchParamType.string
            },
            "labelTranslationKey": "HospitalizationNumber"
        },
        {
            "active": true,
            "property": {
                "name": "braceletNumber",
                "type": SearchParamType.string
            },
            "labelTranslationKey": "BraceletNumber"
        },
        {
            "active": true,
            "property": {
                "name": "idReferringPhysician",
                "type": SearchParamType.filterSelect,
                "itemsSourceInfo": {
                    "form": SearchFormType.EXECUTION,
                    "controllerName": "ListWorkFlow",
                    "methodName": "GetListItems?lsName=lsReferringPhysician",
                    "displayProperty": "description",
                    "enableTooltip": true,
                    "sortCollectionDataInfo": {
                        "field": "description"
                    }
                }
            },
            "labelTranslationKey": "ReferringPhysician"
        },
        {
            "active": true,
            "property": {
                "name": "IdExecutor",
                "type": SearchParamType.filterSelect,
                "itemsSourceInfo": {
                    "form": SearchFormType.EXECUTION,
                    "controllerName": "ListWorkFlow",
                    "methodName": "GetListItems?lsName=lsExecutor",
                    "displayProperty": "description",
                    "enableTooltip": true,
                    "sortCollectionDataInfo": {
                        "field": "description"
                    }
                }
            },
            "labelTranslationKey": "PerformingPhysician"
        }
    ]

}
